<div class="mt-3 col-12" style="display: flex;justify-content: flex-start;" *ngIf="!carregando">
  <div class="col-2 md:col-6 lg:col-3" *ngIf="!carregando" style="padding: 0px 0px 0px 0px;">
    <p-dropdown [options]="dealers" [showClear]="true" optionLabel="descricao" [(ngModel)]="selectedDealer" placeholder="{{'Dealers'}}"></p-dropdown>
  </div>
  <div class="col-2 md:col-6 lg:col-3 ml-2" *ngIf="!carregando" style="padding: 0px 0px 0px 0px;">
    <p-dropdown [options]="status" [showClear]="true" optionLabel="descricao" [(ngModel)]="selectedStatus" placeholder="{{'Status'}}"></p-dropdown>
  </div>
  <div class="col-3 md:col-6 lg:col-3 ml-3 ml-2" *ngIf="!carregando" style="padding: 0px;">
    <div style="display: flex;">
      <button class="btn btn-primary mb-2 buttonPadrao btnBuscar" (click)="buscar()">
        Buscar
        <em class="fa fa-search fa-xs"></em>
      </button>
      <button class="btn btn-secondary mb-2 buttonPadrao btnAtualizar" style="margin-left: 5px;"
        (click)="btnAtualizar()">
        Atualizar
      </button>
    </div>
  </div>
  <div class="md:col-6 lg:col-3 ml-1" *ngIf="!carregando"
    style="padding: 0px;flex: 0 0 41.666667%;max-width: 38.666667%;">
    <button class="btn btn-outline-secondary mb-2 float-right" (click)="exportarExcel()">
      <em class="fa fa-download fa-xs"></em>
      Export Excel
    </button>
  </div>
</div>
<app-loading [exibir]="carregando"></app-loading>
<div class="content mt-3 col-12" *ngIf="!carregando">
  <div *ngIf="servicoDados?.length <= 0" class="sem-registros text-muted mt-2">
    Nenhum registro para exibir...
  </div>
  <p-table #dt dataKey="idStatusServico" *ngIf="servicoDados?.length > 0" [value]="servicoDados"
    selectionMode="multiple" [(selection)]="selectedDados"
    styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm p-datatable-gridlines"
    [columns]="selectedColumns" [columns]="cols" [autoLayout]="true" id="excel-table" [rows]="50"
    [customSort]="true" (sortFunction)="customSort($event)">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="width: 3rem;background: black;">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th *ngFor="let col of columns" [translate]="getTranslate(col.header)" [pSortableColumn]="col.field"
          [ngClass]="{'text-center': col.header.toLowerCase() === 'status'}"
          style="background-color:black;color:white;">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-dados let-columns="columns">
      <tr>
        <td>
          <p-tableCheckbox [value]="dados"></p-tableCheckbox>
        </td>
        <ng-container *ngFor="let col of columns">
          <ng-container *ngIf="col.field === 'precisaAtualizar'">
            <td>
              <p-checkbox class="checkGrid" [(ngModel)]="dados[col.field]" binary="true" disabled="true"></p-checkbox>
            </td>
          </ng-container>
          <ng-container *ngIf="col.field !== 'precisaAtualizar'">
            <td [ngStyle]="{backgroundColor:getColor(dados[col.field])}">
              <div [ngClass]="{'text-center': col.field === 'status'}" [translate]="getTranslate(dados)">
                {{dados[col.field]}}
                <ng-container *ngIf="col.field === 'status'" [translate]="getTranslate(dados[col.field])">
                </ng-container>
              </div>
            </td>
          </ng-container>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
  
  <p-paginator *ngIf="totalRegistros > 25" [rows]="tamanhoPagina" [(first)]="first" [totalRecords]="totalRegistros"
    [rowsPerPageOptions]="[10,30,50,100,200]" (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando {first} à {last} de {totalRecords} registros">
  </p-paginator>
</div>